import { SxProps, Theme } from '@mui/material';

export const tabsRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  height: '40px',
  mt: '20px',
  p: '4px',
  borderRadius: '10px',
  border: '1px solid #E5E7EB',
  backgroundColor: '#FFFFFF',
  width: 'fit-content',
};

export const tabButtonSx = (selected: boolean): SxProps<Theme> => ({
  height: '32px',
  px: '14px',
  borderRadius: '8px',
  textTransform: 'none',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: selected ? 600 : 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
  color: selected ? '#FFFFFF' : '#374151',
  backgroundColor: selected ? '#39A9B1' : 'transparent',
  minWidth: '90px',
  '&:hover': {
    backgroundColor: selected ? '#39A9B1' : '#F3F4F6',
  },
});

export const modalContainerSx: SxProps<Theme> = {
  position: 'absolute',
  width: '460px',
  maxWidth: '95%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '16px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
};

export const modalHeaderSx: SxProps<Theme> = {
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: '24px',
  borderBottom: '1px solid rgba(0,0,0,0.06)',
};

export const modalTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '-0.31px',
  color: '#111827',
};

export const modalBodySx: SxProps<Theme> = {
  px: '24px',
  pt: '20px',
  pb: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
};

export const modalFooterSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  px: '24px',
  pb: '20px',
  pt: '6px',
};

export const fieldLabelSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '20px',
  color: '#374151',
  mb: '6px',
};

export const inputSx: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    height: '41.5px',
    borderRadius: '10px',
    fontFamily: 'Inter, Arial, sans-serif',
    fontSize: '13px',
  },
};

export const cancelButtonSx: SxProps<Theme> = {
  height: '36px',
  px: '14px',
  borderRadius: '10px',
  border: '1px solid #E5E7EB',
  backgroundColor: 'transparent',
  color: '#374151',
  textTransform: 'none',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
};

export const saveButtonSx: SxProps<Theme> = {
  height: '36px',
  px: '18px',
  borderRadius: '10px',
  backgroundColor: '#39A9B1',
  color: '#FFFFFF',
  textTransform: 'none',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  '&:hover': { backgroundColor: '#39A9B1' },
};

export const formErrorSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontSize: '12px',
  color: '#B91C1C',
  mt: '4px',
};
